import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import InvestmentProducts from "./components/InvestmentProducts";
import FeaturedProperties from "./components/FeaturedProperties";
import SocialHousingOverview from "./components/SocialHousingOverview";
import CompanySuccessSection from "./components/CompanySuccessSection";
import StatsSection from "./components/StatsSection";
import PortalBanner from "./components/PortalBanner";
import TestimonialsSection from "./components/TestimonialsSection";
import WhyInvestSection from "./components/WhyInvestSection";
import { Link } from "react-router-dom";

const ctaStats = [
  { icon: "ri-percent-line", value: "10.00% p.a.", label: "Target Return" },
  { icon: "ri-calendar-check-line", value: "Monthly", label: "Income Frequency" },
  { icon: "ri-time-line", value: "5 Years", label: "Investment Term" },
  { icon: "ri-shield-check-line", value: "1st Charge", label: "Asset Security" },
];

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <InvestmentProducts />
      <FeaturedProperties />
      <SocialHousingOverview />
      <CompanySuccessSection />
      <StatsSection />
      <WhyInvestSection />
      <PortalBanner />
      <TestimonialsSection />

      {/* ── CTA Banner ── */}
      <section
        className="relative py-20 md:py-28 overflow-hidden"
        style={{ background: "linear-gradient(135deg, #071A2E 0%, #0D2B4A 55%, #071A2E 100%)" }}
      >
        {/* Decorative glows */}
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] rounded-full pointer-events-none"
          style={{ background: "radial-gradient(ellipse, rgba(201,168,76,0.10) 0%, transparent 70%)" }}
        />
        <div
          className="absolute bottom-0 left-1/4 translate-y-1/2 w-72 h-72 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(201,168,76,0.07) 0%, transparent 70%)" }}
        />
        {/* Gold rules */}
        <div
          className="absolute top-0 left-0 right-0 h-[2px]"
          style={{ background: "linear-gradient(90deg, transparent, #C9A84C 30%, #E2C27A 50%, #C9A84C 70%, transparent)" }}
        />
        <div
          className="absolute bottom-0 left-0 right-0 h-[1px]"
          style={{ background: "linear-gradient(90deg, transparent, rgba(201,168,76,0.3) 40%, rgba(201,168,76,0.3) 60%, transparent)" }}
        />

        <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
          <span className="inline-flex items-center gap-2 bg-[#C9A84C]/12 border border-[#C9A84C]/30 text-[#C9A84C] text-[10px] font-bold uppercase tracking-[0.2em] px-4 py-1.5 rounded-full mb-7">
            <i className="ri-shield-star-line text-xs leading-none" />
            Structured Investment — Qualified Investors Only
          </span>

          <h2
            className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Ready to Invest in
            <br />
            <span style={{ color: "#C9A84C" }}>UK Social Housing?</span>
          </h2>

          <p className="text-slate-400 text-sm md:text-base mb-3 max-w-xl mx-auto leading-relaxed">
            Explore the full product documentation or speak directly with our investment team.
          </p>
          <p className="text-slate-600 text-xs mb-10 max-w-md mx-auto">
            Capital is at risk. Please read the full Information Memorandum before investing.
          </p>

          {/* Stats strip */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-5 mb-10">
            {ctaStats.map((s) => (
              <div
                key={s.label}
                className="flex items-center gap-2.5 bg-white/5 border border-white/10 rounded-xl px-4 py-3"
              >
                <div className="w-4 h-4 flex items-center justify-center text-[#C9A84C]">
                  <i className={`${s.icon} text-sm leading-none`} />
                </div>
                <div className="text-left">
                  <p className="text-white font-bold text-sm leading-none">{s.value}</p>
                  <p className="text-slate-500 text-[10px] mt-0.5">{s.label}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/social-housing"
              className="inline-flex items-center justify-center gap-2.5 px-7 py-4 rounded-full font-bold text-sm cursor-pointer whitespace-nowrap transition-all hover:brightness-110"
              style={{ background: "linear-gradient(135deg, #C9A84C 0%, #E2C27A 50%, #C9A84C 100%)", color: "#071A2E" }}
            >
              <i className="ri-file-text-line leading-none" />
              View Full Product Details
            </Link>
            <Link
              to="/brochure"
              className="inline-flex items-center justify-center gap-2.5 px-7 py-4 rounded-full border border-white/25 text-white font-semibold text-sm hover:bg-white/8 hover:border-white/40 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-download-line leading-none" />
              Download Brochure
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2.5 px-7 py-4 rounded-full border border-white/15 text-white/70 font-semibold text-sm hover:bg-white/6 hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line leading-none" />
              Speak to Our Team
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
